import { createSlice } from "@reduxjs/toolkit";
import { SHOW_ROOMS_LOCATIONS_INFO } from "../../components/Homepage/constants";
import { sendAnalytics } from "@/utils/helpers/analytics";

const initialState = {
  geolocation: null,
  isLoading: true,
  city: "Others",
  showRoomLocatorData: SHOW_ROOMS_LOCATIONS_INFO,
  showRoomLocatorDataLoading: false,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocationInfo(state = initialState, action) {
      return {
        ...state,
        geolocation: action.payload?.geolocation,
        isLoading: action.payload?.isLoading,
      };
    },
    setCity: (state, action) => {
      const { selectedCity } = action.payload;
      state.city = selectedCity;
      sendAnalytics("city_change", { selectedCity: selectedCity });
    },
  },
});

export const { setLocationInfo, setCity } = locationSlice.actions;

export default locationSlice.reducer;
